export default __webpack_public_path__ + "static/media/vocalnet.a35dbce0.mp4";